module.exports = __webpack_public_path__ + "img/ma256.6c90ee49.png";